import React from 'react';
import { TailSpin } from 'react-loader-spinner';

export const AuditPage = ({ 
  isAuditPageOpen, 
  setIsAuditPageOpen, 
  selectedUserForAudit, 
  isLoadingAudit, 
  auditData 
}) => {
  if (!isAuditPageOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-white">
      <div className="flex items-center justify-between p-4 px-20 border-b">
        <h2 className="text-2xl font-semibold text-gray-800">
          User Audit - {selectedUserForAudit?.name || "User"}
        </h2>
        <button
          onClick={() => setIsAuditPageOpen(false)}
          className="p-2 text-gray-500 hover:text-gray-700"
        >
          <i className="text-xl fas fa-arrow-left"></i> Back
        </button>
      </div>

      {isLoadingAudit ? (
        <div className="flex items-center justify-center h-full">
          <div className="flex items-center justify-center">
            <div className="w-8 h-8 border-4 border-black rounded-full border-t-transparent animate-spin"></div>
          </div>
        </div>
      ) : auditData?.data && auditData.data.length > 0 ? (
        <div className="p-6 overflow-y-auto">
          <div className="max-w-4xl mx-auto">
            <h3 className="mb-6 text-xl font-semibold">Transaction History</h3>
            <div className="space-y-4">
              {auditData.data.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between p-4 mb-4 bg-white border rounded-lg shadow-sm"
                >
                  <div className="flex gap-4">
                    <i className={`h-10 mt-2 justify-center w-10 flex items-center text-xl ${item.isDebit ? 'text-red-600' : 'text-green-600'} bg-gray-100 rounded-[100px] fas ${item.isDebit ? 'fa-arrow-up' : 'fa-arrow-down'}`}></i>
                    <div className="items-center justify-between">
                      <h3 className="text-lg font-semibold text-gray-500">ID: {item.docID}</h3>
                      <p>{new Date(item.createdAt).toLocaleString()}</p>
                    </div>
                  </div>
                  <div className="text-sm text-gray-700">
                    <p className="pt-3 font-semibold text-gray-800 text-md">
                      {item.isDebit ? 
                        `Send: ${item.send}` : 
                        `Receive: ${item.receive}`}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-full">
          <p className="text-xl text-gray-600">No audit data found.</p>
        </div>
      )}
    </div>
  );
};

